import { authAction } from "./auth/authAction";
import { banHangAction } from "./ban-hang/banHangAction";
import { coSoActions } from "./category/coSoActions";
import { donViTinhActions } from "./category/donViTinhActions";
import { heActions } from "./category/heActions";
import { hinhThucThanhToanActions } from "./category/hinhThucThanhToanActions";
import { khoActions } from "./category/khoActions";
import { khoiActions } from "./category/khoiActions";
import { lopActions } from "./category/lopActions";
import { namHocActions } from "./category/namHocActions";
import { nhapKhoActions } from "./category/nhapKhoActions";
import { tienThuaHocSinhActions } from "./category/tienThuaHocSinhActions";
import { categoryComboActions } from "./category/categoryComboActions";
import { categoryMenuActions } from "./category/categoryMenuActions";
import { layoutActions } from "./common/layoutActions";
import { donHangActions } from "./don-hang/donHangActions";
import { donHangChiTietAction } from "./don-hang/donHangChiTietAction";
import { donHangViewChiTietAction } from "./don-hang/donHangViewChiTietAction";
import { emailPhuHuynhActions } from "./don-hang/emailPhuHuynhAction";
import { trangThaiKhoActions } from "./quan-ly-kho/trangThaiKhoActions";
import saleSetActions from "./saleSet";
import { categoryActions } from "./san-pham/categoryActions";
import { sanPhamActions } from "./san-pham/sanPhamActions";
import { sanPhamChiTietChiTiet } from "./san-pham/sanPhamChiTiet";
import { sanPhamPhamViActions } from "./san-pham/sanPhamPhamViActions";
import { setTieuChuanActions } from "./set-tieu-chuan/setTieuChuanActions";
import { setTieuChuanHocSinhActions } from "./set-tieu-chuan/setTieuChuanHocSinhActions";
import { setTieuChuanSanPhamActions } from "./set-tieu-chuan/setTieuChuanSanPhamActions";

export const rootActions = {
  auth: authAction,
  common: {
    layout: layoutActions,
  },
  category: {
    donViTinh: donViTinhActions,
    hinhThucThanhToan: hinhThucThanhToanActions,
    coSo: coSoActions,
    he: heActions,
    khoi: khoiActions,
    lop: lopActions,
    namHoc: namHocActions,
    kho: khoActions,
    nhapKho: nhapKhoActions,
    tienThuaHocSinh: tienThuaHocSinhActions,
    categoryCombo: categoryComboActions,
    categoryMenu: categoryMenuActions
  },
  sanPham: {
    sanPhamChiTiet: sanPhamChiTietChiTiet,
    sanPham: sanPhamActions,
    category: categoryActions,
    sanPhamPhamVi: sanPhamPhamViActions
  },
  banHang: banHangAction,
  donHang: {
    donHang: donHangActions,
    donHangViewChiTiet: donHangViewChiTietAction,
    donHangChiTiet: donHangChiTietAction,
    emailPhuHuynh: emailPhuHuynhActions
  },
  setTieuChuan: {
    setTieuChuan: setTieuChuanActions,
    sanPham: setTieuChuanSanPhamActions,
    hocSinh: setTieuChuanHocSinhActions
  },
  quanLyKho: {
    trangThaiKho: trangThaiKhoActions
  },
  saleSet: saleSetActions
}
